import React from 'react'
import { renderToString } from 'react-dom/server'

import OnboardingNonRxEmailSubmissionTikTok from 'components/PrePurchaseSurvey/EmailSubmission/OnboardingNonRxEmailSubmissionTikTok'
import { states } from 'shared/states'
import { SubscriptionType } from 'types/SurveyInterface'
import NotAvailableOnState from './EmailSubmission/NotAvailableOnState'
import { registerWelcomeQuestion } from './Welcome/Welcome'

// Welcome
const welcomeQuestionType = registerWelcomeQuestion()
export const welcomePageName = 'welcome'

// Unchanging survey variables
const requiredText = 'Please select an answer'

// pages const
export const penultimatePageName = 'medical-conditions'
export const videoIntroPageName = 'program-introduction'
export const weightLossPercentPageName = 'weight-loss-percent'
export const geneticsWeightPercentPageName = 'genetics-weight-percent'
export const medsForWeightLossPageName = 'meds-for-weight-loss'
export const letsGetPersonalPageName = 'lets-get-personal'
export const medicationBasedIntentPage = 'medicationBasedIntentPage'
export const state = 'state'
export const resultsPage = 'results'
export const PPQLastPageSlider = 'lastPageSlider'
export const lastQuestionBeforePrequalification = 'medicalConditions'
export const foundProgramBeginning = 'foundProgramBeginning'
export const foundProgramEnd = 'foundProgramEnd'
export const ppqWeightGraph = 'ppqWeightGraph'
export const smsTermsCheckbox = 'smsTermsCheckbox'
export const adultWeight = 'lowest-adult-weight'

//insurance pages
export const insurancePreferencesPageName = 'insurance-preferences'
export const insuranceFaq = 'insuranceFaq'
export const insuranceGroupIdPage = 'insurance-group-id'

export const coveredByShamrockFoods = 'covered-by-shamrock-foods'

export const notCoveredByShamrockFoods = 'not-covered-by-shamrock-foods'

export const pagesWithImage = [
  'meds',
  'greetings',
  'additional-motivation',
  'biology-2',
  'rx-interstitial',
  'insurance-interstitial',
  'results',
]

export const hideProgressBarPages: string[] = [
  welcomePageName,
  letsGetPersonalPageName,
  'rx-interstitial',
  'results',
]

export const ppqReskinGreenPages: string[] = []

export const insuranceFlowPages = [insuranceGroupIdPage]

const isRxType = `({prequalificationType} = '${SubscriptionType.Rx}' or {prequalificationType} = '${SubscriptionType.RxInsurance}')`
const isNotRxType = `({prequalificationType} != '${SubscriptionType.Rx}' and {prequalificationType} != '${SubscriptionType.RxInsurance}')`

export const jsonStructure = () => {
  const NotAvailableOnStatePage = renderToString(<NotAvailableOnState />)
  const OnboardingNonRxEmailSubmissionTikTokPage = renderToString(
    <OnboardingNonRxEmailSubmissionTikTok />,
  )

  return {
    focusOnFirstError: false,
    goNextPageAutomatic: false,
    showCompletedPage: false,
    pages: [
      {
        name: welcomePageName,
        elements: [
          {
            name: 'welcome-onboarding',
            type: welcomeQuestionType,
          },
        ],
      },
      {
        name: 'date-of-birth',
        elements: [
          {
            name: 'dateOfBirth',
            type: 'text',
            title: 'What is your date of birth?',
            description:
              'We want to get to know you better to create the best possible plan for you.',
            requiredErrorText: 'Please enter your date of birth.',
            isRequired: true,
            validators: [
              {
                type: 'expression',
                text: 'Should be in format mm-dd-yyyy',
                expression: 'dateWidgetValidator({dateOfBirth})',
              },
              {
                type: 'expression',
                text: 'Please make sure that your date of birth is correct. ({dateOfBirth})',
                expression: 'adultValidator({dateOfBirth})',
              },
            ],
          },
        ],
      },
      // state selection
      {
        name: state,
        elements: [
          {
            name: 'state',
            renderAs: 'native-dropdown',
            type: 'dropdown',
            title: 'What state do you live in?',
            placeholder: 'Select your state of residency',
            isRequired: true,
            searchEnabled: false,
            choices: states,
            showNoneItem: true,
            noneText: 'Other region not listed',
          },
        ],
      },
      {
        name: 'gender-identity',
        elements: [
          {
            name: 'genderIdentity',
            type: 'radiogroup',
            title: 'What is your gender identity?',
            isRequired: true,
            requiredErrorText: requiredText,
            colCount: 1,
            choices: [
              'Man',
              'Woman',
              'Transgender man',
              'Transgender woman',
              'Non-binary or non-conforming',
              'Another identity',
              'Decline to answer',
            ],
          },
          {
            name: 'ensureSafety',
            type: 'html',
            html: '<p class="ensure-safety__title no-margin">Once you sign up, we’ll securely pass this info to your Found medical provider to ensure your weight care path is safe and effective. You’ll also be able to share more details during your medical consult. </p>',
          },
        ],
      },
      {
        name: 'biological-sex',
        elements: [
          {
            name: 'biologicalSex',
            type: 'radiogroup',
            title: 'What was your sex assigned at birth?',
            isRequired: true,
            requiredErrorText: requiredText,
            colCount: 1,
            choices: ['Male', 'Female', 'Intersex', 'Decline to answer'],
          },
          {
            name: 'ensureSafety',
            type: 'html',
            html: '<p class="ensure-safety__title no-margin">Once you sign up, we’ll securely pass this info to your Found medical provider to ensure your weight care path is safe and effective. You’ll also be able to share more details during your medical consult. </p>',
          },
        ],
      },
      {
        name: 'pregnancy',
        elements: [
          {
            name: 'isPregnant',
            visibleIf: "{biologicalSex} != 'Male'",
            type: 'radiogroup',
            title: 'Are you pregnant, nursing, or trying to get pregnant?',
            isRequired: true,
            requiredErrorText: requiredText,
            colCount: 1,
            choices: ['Yes', 'No'],
          },
        ],
      },
      {
        name: 'height',
        elements: [
          {
            type: 'multipletext',
            name: 'height',
            title: 'What is your height?',
            colCount: 1,
            isRequired: true,
            requiredErrorText: 'Please enter your height',
            items: [
              {
                name: 'feet',
                title: 'Feet',
                placeHolder: 'Feet',
                validators: [
                  {
                    type: 'numeric',
                    minValue: 2,
                    maxValue: 8,
                  },
                ],
              },
              {
                name: 'inches',
                title: 'Inches',
                placeHolder: 'Inches',
                validators: [
                  {
                    type: 'numeric',
                    minValue: 0,
                    maxValue: 11,
                  },
                ],
              },
            ],
          },
          {
            name: 'totalHeightInches',
            type: 'expression',
            visibleIf: 'false',
            expression: 'calculateHeightInInches({height})',
          },
        ],
      },
      {
        name: 'weight',
        elements: [
          {
            name: 'weightLbs',
            title: 'What is your current weight?',
            description:
              'This helps us calculate your BMI. BMI is one factor that we use to determine your weight care path, so it’s important to be as accurate as possible.',
            type: 'text',
            isRequired: true,
            placeHolder: 'Weight in lbs',
            requiredErrorText: 'Please enter your current weight',
            inputType: 'number',
          },
        ],
      },
      {
        name: 'goalWeight',
        elements: [
          {
            name: 'goalWeightLbs',
            title: 'What is your goal weight?',
            description: "Let's work together to get you closer to your goal weight!",
            type: 'text',
            isRequired: true,
            placeHolder: 'Weight in lbs',
            requiredErrorText: 'Please enter your goal weight',
            inputType: 'number',
          },
        ],
      },
      {
        name: 'bmi',
        elements: [
          {
            name: 'bmi',
            visibleIf: 'false',
            type: 'expression',
            title: 'Your current BMI is:',
            expression: 'calculateBMI({weightLbs}, {height})',
          },
        ],
      },
      {
        name: adultWeight,
        visibleIf: '{bmi} < 30',
        elements: [
          {
            name: 'lowestWeightLbs',
            title:
              'What is the lowest weight you have maintained for at least a year as an adult (18+)?',
            type: 'text',
            placeHolder: 'Weight in lbs',
            inputType: 'number',
          },
        ],
      },
      {
        name: 'family-members',
        elements: [
          {
            name: 'familyMembers',
            type: 'checkbox',
            title:
              'Have any of your family members (grandparents, parents, siblings or children) been diagnosed with any of the following conditions?',
            description: 'Please check all that apply.',
            isRequired: true,
            showNoneItem: true,
            noneText: 'None of the above',
            choices: ['Pre-diabetes', 'Diabetes', 'Obesity', 'Overweight'],
          },
        ],
      },
      {
        name: 'health-conditions',
        elements: [
          {
            name: 'healthConditions',
            type: 'checkbox',
            title: 'Do you have any of the following conditions?',
            description: 'Please check all that apply.',
            isRequired: true,
            requiredErrorText: requiredText,
            hasNone: true,
            noneText: 'None / NA',
            choices: [
              'High blood pressure',
              'High cholesterol',
              'High triglycerides',
              'Pre-diabetes',
              'Type II diabetes',
              'Joint pain',
              'Sleep apnea',
              'Fatty liver',
              'Back pain',
              'Arthritis',
              'Nerve pain',
              'Cancer',
              'Depression',
              'Anxiety',
              'Hypothyroidism',
              'Asthma',
              'Infertility',
              'PCOS (polycystic ovary syndrome)',
              'Menopause',
              'Gestational diabetes',
            ],
          },
        ],
      },
      {
        name: penultimatePageName,
        elements: [
          {
            name: lastQuestionBeforePrequalification,
            type: 'checkbox',
            isRequired: true,
            requiredErrorText: requiredText,
            title:
              'Have you ever been treated for or diagnosed with any of the following medical conditions?',
            description: 'Please check all that apply.',
            showNoneItem: true,
            noneText: 'None / NA',
            choices: [
              'Undergoing dialysis',
              'Kidney transplant',
              'Stroke (within the last year)',
              'Heart failure',
              'Myocardial infarction (heart attack) (within the last year)',
              'Heart transplant',
              'Active cancer undergoing treatment (such as chemotherapy, radiation, etc.)',
              'Suicide attempts / ideation',
              'Psychosis, schizophrenia, or schizoaffective disorder',
              'Anorexia or bulimia',
              'Liver failure',
              'Liver transplant',
            ],
          },
        ],
      },
      {
        name: 'eligibleForGLP1',
        elements: [
          {
            name: 'eligibleForGLP1',
            type: 'expression',
            expression: `calculateGLP1Eligibility({bmi}, {healthConditions})`,
            visibleIf: 'false',
          },
        ],
      },
      {
        name: 'rx-interstitial',
        visibleIf: `${isRxType}`,
        elements: [
          {
            type: 'html',
            name: 'rxInterstitial',
            html: `
                <div class="ppq-interstitial">
                  <p class="ppq-interstitial__title no-margin">Congratulations! Let's get you started.</p>
                  <p class="ppq-interstitial__description no-margin">You’re in great hands with Found. After you become a member, our clinical team will assess your metabolic health profile, determine the best course of treatment and hold your hand every step of the way.</p>
                  <p class="ppq-interstitial__description no-margin">We can’t wait to get you to your goals.</p>
                </div>`,
          },
        ],
      },

      // results
      {
        name: resultsPage,
        elements: [
          {
            name: 'notAvailableOnStatePageText',
            visibleIf: `${isNotRxType} and !{isStateIncluded}`,
            type: 'html',
            html: NotAvailableOnStatePage,
          },
          {
            name: 'lastPageTextTikTok',
            visibleIf: `${isNotRxType} and {isStateIncluded} and {isTikTok}`,
            type: 'html',
            html: OnboardingNonRxEmailSubmissionTikTokPage,
          },
          {
            type: 'html',
            name: 'rxEmailSubmissionText',
            visibleIf: '{isStateIncluded} and !{isTikTok}',
            html: `<p class="rx-onboarding-text no-margin">Last step — please enter your email, so we can save your progress:</p>`,
          },
          {
            type: 'text',
            name: 'email',
            titleLocation: 'hide',
            isRequired: true,
            placeHolder: 'Email',
            validators: [
              {
                type: 'expression',
                text: 'Please make sure that your email is correct',
                expression: 'emailValidator({email})',
              },
            ],
          },
        ],
      },
    ],
  }
}

export const INDEX_PAGE = 'index'
